import { useTranslation } from 'react-i18next'
import React from 'react'

import { useSaveFormReply } from './_requests/saveFormReply'
import FlexGrid from '../../../components/structure/FlexGrid'
import IconButton from '../../../components/actions/IconButton'
import Separator from '../../../components/helpers/Separator'
import { useForm } from './_load/FormLoader'

const Footer = () => {
  const { t } = useTranslation('common')
  const [submit, { loading }] = useSaveFormReply()
  const form = useForm()

  return (
    <div>
      <Separator weight={4} />
      <FlexGrid justify="flex-end" flex={0}>
        <IconButton
          icon="BsCheckCircle"
          color={form.themeColor}
          label={t('submit')}
          onClick={submit}
          loading={loading}
        />
      </FlexGrid>
    </div>
  )
}

export default Footer
